import { Pagination } from "antd";

// Props: current (1-based), total (num. de registros), pageSize, onChange(page), size ("sm" | undefined)
export default function AppPagination({ current, total, pageSize, onChange, size, className = "" }) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (pageCount <= 1) return null;

  return (
    <Pagination
      current={current}
      total={total}
      pageSize={pageSize}
      onChange={onChange}
      size={size === "sm" ? "small" : undefined}
      className={className}
      showSizeChanger={false}
    />
  );
}
